import Swiper from "swiper";
import { Autoplay, Navigation } from "swiper/modules";
import { getRem } from "./utils/utils";
import "swiper/css/bundle";

export const initSlider = () => {
  const regularSliders = document.querySelectorAll(
    "[data-regular-slider]",
  ) as NodeListOf<HTMLElement>;

  if (regularSliders.length > 0) {
    for (const slider of regularSliders) {
      const sliderContainer = slider.closest(".slider-container");
      const prevButton = sliderContainer?.querySelector(
        "button.nav-button.--prev",
      ) as HTMLElement;
      const nextButton = sliderContainer?.querySelector(
        "button.nav-button.--next",
      ) as HTMLElement;

      new Swiper(slider, {
        modules: [Navigation],
        speed: 700,
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton,
        },
        breakpoints: {
          0: {
            slidesPerView: "auto",
            spaceBetween: 12 * getRem(),
          },
          769: {
            slidesPerView: 2,
            spaceBetween: 12 * getRem(),
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 20 * getRem(),
          },
        },
      });
    }
  }

  const integrationsSlider = document.getElementById(
    "integrations-slider",
  ) as HTMLElement;

  if (integrationsSlider) {
    new Swiper(integrationsSlider, {
      modules: [Autoplay],
      loop: true,
      speed: 4000,
      allowSlidePrev: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      allowTouchMove: true,
      grabCursor: true,
      breakpoints: {
        0: {
          slidesPerView: "auto",
          spaceBetween: 10 * getRem(),
        },
        769: {
          slidesPerView: 4,
          spaceBetween: 20 * getRem(),
        },
        1200: {
          slidesPerView: 6,
          spaceBetween: 50 * getRem(),
        },
      },
    });
  }
};
